// extracted by mini-css-extract-plugin
export default {"content":"styles_content__79IJy","center":"styles_center__pl1dH","label":"styles_label__-hDcY"};